import "react-time-picker/dist/TimePicker.css";
import "./style.css";

import { useFormContext } from "react-hook-form";
import TimePicker from "react-time-picker";

import { CustomButton } from "@/components/atoms";
import { cn } from "@/lib/utils";

import type { BranchHoursFormType } from "./types";

type Props = {
  hour: BranchHoursFormType["schedules"][number];
  index: number;
  applyToAll: (index: number) => void;
};

const formatTime = (val: string) => {
  const [hours, minutes] = val.split(":");
  return `${hours.padStart(2, "0")}:${minutes.padStart(2, "0")}`;
};

const CustomTimePicker = ({ hour, index, applyToAll }: Props) => {
  const { setValue, watch } = useFormContext<BranchHoursFormType>();
  const openTime = watch(`schedules.${index}.open`);
  const closeTime = watch(`schedules.${index}.close`);

  return (
    <>
      <div
        className={cn(
          "flex items-center gap-[8px] w-full",
          hour.closed
            ? "ml-0 sm:ml-[7px] opacity-30 pointer-events-none"
            : "ml-0 sm:ml-4"
        )}
      >
        <TimePicker
          onChange={val => {
            if (val) {
              setValue(`schedules.${index}.open`, formatTime(val), {
                shouldValidate: true,
                shouldDirty: true,
              });
            }
          }}
          value={openTime}
          disableClock
          locale="en-US"
          clearIcon={null}
          clockIcon={null}
          format="h:mm a"
          data-testid={`branch-hours-open-${hour.day}`}
        />

        <span className="text-sm">TO</span>

        <TimePicker
          onChange={val => {
            if (val) {
              setValue(`schedules.${index}.close`, val, {
                shouldValidate: true,
                shouldDirty: true,
              });
            }
          }}
          value={closeTime}
          disableClock
          locale="en-US"
          clearIcon={null}
          clockIcon={null}
          format="h:mm a"
          data-testid={`branch-hours-close-${hour.day}`}
        />
      </div>

      <CustomButton
        type="button"
        variant="blue"
        className="px-0"
        onClick={() => applyToAll(index)}
        data-testid={`branch-hours-apply-${hour.day}`}
        disabled={hour.closed}
      >
        Apply to all
      </CustomButton>
    </>
  );
};

export default CustomTimePicker;
